import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useBooking } from "./BookingContext";
import { MaskLine, LuxButton } from "./primitives";
import { IMAGES } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function FinalCTA() {
  const { openBooking } = useBooking();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="final-cta-section"
      className="relative flex min-h-[100svh] items-center overflow-hidden bg-charcoal text-warm grain"
    >
      <motion.img
        style={{ y, scale: 1.12 }}
        src={IMAGES.finalCta}
        alt="Luxury villa at dusk"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-45"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/60 to-charcoal/30" />

      <div className="relative z-10 mx-auto w-full max-w-[1600px] px-6 py-28 md:px-12">
        <span className="overline text-champagne">The Decision</span>
        <h2 className="mt-8 max-w-[18ch] font-serif text-4xl leading-[1.05] sm:text-6xl lg:text-[5rem]">
          <MaskLine trigger="load" delay={0}>Your family will live</MaskLine>
          <MaskLine trigger="load" delay={0.08}>with these decisions</MaskLine>
          <MaskLine trigger="load" delay={0.16} className="italic text-champagne">
            for decades.
          </MaskLine>
        </h2>
        <p className="mt-8 max-w-[44ch] text-lg leading-relaxed text-warm/70 md:text-2xl">
          Let&apos;s make sure they&apos;re the right ones.
        </p>

        <div className="mt-12">
          <LuxButton testid="final-cta-button" variant="light" onClick={openBooking}>
            Book Your Villa Design Strategy Call
          </LuxButton>
        </div>

        <p className="overline mt-10 text-warm/40">
          Only a limited number of strategy sessions are offered each month.
        </p>
      </div>
    </section>
  );
}
